
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/digital/[slug]",
      function () {
        return require("private-next-pages/[locale]/digital/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/digital/[slug]"])
      });
    }
  